{
    "bannerImgs": ["header.png"]
}
